import { ApplicationRef, Injectable, NgZone } from '@angular/core';
import { EventManager } from '@angular/platform-browser';

@Injectable()
export class ZonelessEventsPlugin {
  
  protected readonly manager!: EventManager;

  constructor(protected readonly appRef: ApplicationRef) { }

  protected supports(): boolean{
    return !(this.manager.getZone() instanceof NgZone);
  }

  protected addEventListener(element: HTMLElement, eventName: string, handler: Function): Function{
    const eventHandler = (...args: any[]) => {
      handler.apply(element, args);
      this.appRef.tick();
    };

    element.addEventListener(eventName, eventHandler, false);
    return () => this.removeEventListener(element, eventName, eventHandler);
  }

  protected removeEventListener(target: any, eventName: string, callback: Function): void{
    return target.removeEventListener(eventName, callback as EventListener);
  }
}
